/** 최근 본 상품 조회 API 공통 쿼리스트링 생성 (noLoginCookieUserNo / typeValue). */
export function buildRecentViewQuery(
  noLoginCookieUserNo?: string,
  typeValue?: string,
) {
  const search = new URLSearchParams();
  if (noLoginCookieUserNo) {
    search.append('noLoginCookieUserNo', noLoginCookieUserNo);
  }
  if (typeValue) {
    search.append('typeValue', typeValue);
  }
  return search.toString();
}
